export const SET_SALES_ORDER_CONFIG = 'SET_SALES_ORDER_CONFIG'



// WEBPACK FOOTER //
// ./src/types/salesOrder.js